export default __webpack_public_path__ + "img/markup_tools/highlighter_tool_disabled.svg";